<ion-content>
  @if (!videoBoardSettingsLoaded()) {
    <div class="loading-container">
      <ion-spinner name="crescent" size="large"></ion-spinner>
    </div>
  } @else {
  <ion-list class="content-width">
    <ion-item>
      <ion-select
        label="{{ 'Address' | translate }}"
        label-placement="stacked"
        value="{{ videoBoardSettings()?.addressFormat || 'none' }}"
        interface="popover"
        (ionChange)="addressFormatChanged($event.detail.value)" 
      >
        <ion-select-option *ngFor="let addressFormat of addressFormats" [value]="addressFormat.code">{{ addressFormat.name | translate }}</ion-select-option>
      </ion-select>
    </ion-item>
    <!-- Dynamic Logo Items -->
    @for (logo of logos(); track logo.id) {
      <ion-item>
        <ion-label position="stacked">{{ logo.name | translate }}</ion-label>
        <div class="upload-image ion-padding-bottom">
          <app-upload-image 
            (imageSelected)="imageSelected($event, logo.id)" 
            [userImage]="getLogoImage(logo.id)"
            [cropImage]="false">
          </app-upload-image>
        </div>
      </ion-item>
    }
  </ion-list>
  
  <ion-list class="content-width">
    <ion-button
      color="primary m-250"
      (click)="submit()"
      expand="block"
      [disabled]="!isDisabled()"
    >
      @if (isLoading()) {
        <ion-spinner name="crescent" size="small"></ion-spinner>
        {{ 'Uploading...' | translate }}
      } @else {
        {{ 'Save' | translate }}
      }
    </ion-button>
  </ion-list>
}
</ion-content>

